import React from "react";
import PropTypes from "prop-types";
import {Query} from "@apollo/client/react/components";
import {Select} from "@unibuddy/patron";

import universityDegreeLevelsQuery from "../../queries/universityDegreeLevelsQuery";

const DegreeLevelSelect = ({universitySlug, ...props}) => (
    <Query variables={{universitySlug}} query={universityDegreeLevelsQuery}>
        {({data, error}) =>
            !error && (
                <Select
                    data-test-id="degree-level"
                    placeholder={props.placeholder}
                    {...props}
                    formatValue={(e) => e}
                >
                    {((data && data.allDegreeLevels) || []).map((level) => (
                        <option key={level.id} value={level.name}>
                            {level.name}
                        </option>
                    ))}
                </Select>
            )
        }
    </Query>
);

DegreeLevelSelect.propTypes = {
    name: PropTypes.string.isRequired,
    universitySlug: PropTypes.string.isRequired,
};
DegreeLevelSelect.defaultProps = {
    placeholder: "Select level",
};

export default DegreeLevelSelect;
